import { MapfreButtonComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { AuthenticationService } from '../../_services/_iam/authentication-service.service';
import { ErrorRedirectionService } from '../../_services/error-service/error-redirection.service';
import { ValidateEmailService } from '../../_services/signup-process-service/validate-email.service';
import { EmailService } from '@services/email/email.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-link-expire',
  templateUrl: './link-expire.component.html',
})
export class LinkExpireComponent implements OnInit {
  email: string;
  maskEmail: string;
  token: string;

  constructor(
    private activeRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    public router: Router,
    private errorRedirectionService: ErrorRedirectionService,
    private validateEmailService: ValidateEmailService,
    private emailService: EmailService,
  ) {}

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((params: Params) => {
      this.email = params.email;
      this.token = params.token;
      if (this.email) {
        this.maskEmail = this.emailService.maskEmail(params.email);
      }
    });
  }
  sendNewEmail() {
    this.authenticationService.verifyForUserExists(this.email).subscribe(
      (resp) => {
        if (resp) {
          this.router.navigate(['signup', 'account-exists']);
        } else {
          this.triggerSendValidationEmail(this.email);
        }
      },
      () => {
        this.triggerSendValidationEmail(this.email);
      }
    );
    // this.authenticationService.activateAccount(this.email).subscribe(
    //   (resp) => {
    //     if (resp) {
    //       this.router.navigate(['signup', 'account-exists']);
    //     } else {
    //       this.triggerSendValidationEmail(this.email);
    //     }
    //   },
    //   (error) => {
    //     this.triggerSendValidationEmail(this.email);
    //   }
    // );
  }

  triggerSendValidationEmail(email) {
    this.validateEmailService
      .sendValidationEmailForNonCommercial(email)
      .subscribe(
        () => {
          this.router.navigate(['signup', 'validate-account']);
        },
        (error) => {
          this.errorRedirectionService.errorHandler(
            error,
            'VERIFICATION_EMAIL_ERROR'
          );
        }
      );
  }
}
